import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const IdLocalStorageLang = 'lang';

const defaultLocal: Language = { shortName: 'en-gb', name: 'English' };

const availableLanguage: Language[] = [
  defaultLocal,
  { shortName: 'fr', name: 'French' },
  { shortName: 'he', name: 'Hebrew' },
  { shortName: 'ar', name: 'Arabic' },
  { shortName: 'ru', name: 'Russian' }
];

export interface Language {
  readonly shortName: string;
  readonly name: string;
}

@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.css']
})
export class SelectLanguageComponent implements OnInit {

  public static getAvailableLanguage(): Language[] {
    return availableLanguage;
  }

  // /!\ Ne supporte que les formats anglais, français et hébreu /!\
  // Renvoit la langue utilisée tant que son formattage est supportée cf registerLocaleData dans app.module.ts
  /// Locales supportées : Français, Anglais (UK), Hébreu
  public static getCurrentLocale(): Language {
    let language: Language = defaultLocal;
    try {
      const lsLang = localStorage.getItem(IdLocalStorageLang);
      if (lsLang != null)
        language = JSON.parse(lsLang);
      if (!language)
        language = defaultLocal;
    } catch (error) {
      if (!language) {
        language = defaultLocal;
      }
    }
    // On ne peut renvoyer que les langues qui ont un formattage supporté
    if (['UK', 'FR', 'HE'].indexOf(language.shortName.toUpperCase()) == -1) {
      language = defaultLocal;
    }
    return language;
  }

  constructor(
    private translate: TranslateService
  ) {
    this.translate.use(this.getLocal().shortName);
  }

  ngOnInit() { }

  public getArrayAvailableLanguage(): any {
    return availableLanguage;
  }

  /**
   * Retounre le language utiliser pour le programme
   */
  public getLocal(): Language {
    let lang: Language | undefined = undefined;
    // On recherche dans le local storage si on astocké la langue de l'utilisteur
    try {
      const strLsLang = localStorage.getItem(IdLocalStorageLang);
      if (strLsLang != null)
        lang = JSON.parse(strLsLang);
    } catch (error) { }
    if (!lang) {
      // Si aucune langue enregistré on enregistre la langue par rapport a cellui du navigateur
      // Anglais si langue navigateur pas geré
      lang = defaultLocal;
      const browserLang = this.translate.getBrowserLang();
      for (let i = 0; i < availableLanguage.length; i++) {
        if (availableLanguage[i].shortName == browserLang) {
          lang = availableLanguage[i];
          break;
        }
      }
      this.saveLocal(lang);
    }
    return lang;
  }

  public getStringLocal(shorName: boolean = false) {
    const local = this.getLocal();
    return shorName ? local.shortName : local.name;
  }

  /**
   * Enregistre le language utiliser par le programme
   * @param lang noueau language
   */
  public saveLocal(lang: Language) {
    localStorage.setItem(IdLocalStorageLang, JSON.stringify(lang));
  }

  public findLanguageByShortName(shortName: string): Language {
    for (let i = 0 ; i < availableLanguage.length ;  i++) {
      if (availableLanguage[i].shortName == shortName)
        return availableLanguage[i];
    }
    return defaultLocal;
  }

  public onLanguageChange(shortName: string) {
    console.log('onLanguageChange: ', shortName);
    const local = this.findLanguageByShortName(shortName);
    console.log('local: ', local);
    this.translate.use(local.shortName);
    this.saveLocal(local);
  }

}
